import {Salepoint} from "./domain.ts";

const basketKey = "BK"
const shopKey="SHP"
const loadBasketIDFromLS= ():string|undefined => {
    return window.localStorage.getItem(basketKey)
}
const saveBasketIDToLS = (id: string) => {
    window.localStorage.setItem(basketKey, id)
}

const deleteBasketIDFromLS = () => {
    window.localStorage.removeItem(basketKey)
}

function saveFavoriteShopToLS(s: Salepoint) {
    window.localStorage.setItem(shopKey, JSON.stringify(s))
}
function loadFavoriteShopFromLS(): Salepoint| undefined {
    const s = window.localStorage.getItem(shopKey)
    if (s) {
        return JSON.parse(s)
    }
    return undefined
}
function deleteFavoriteShopFromLS() {
    window.localStorage.removeItem(shopKey)
}
export {loadBasketIDFromLS, saveBasketIDToLS, deleteBasketIDFromLS, saveFavoriteShopToLS, loadFavoriteShopFromLS, deleteFavoriteShopFromLS}
